import {Component, ElementRef, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {ImageResource} from '@services/resource/image-resource';
import {FileCheckService} from '@services/file-check.service';
import {ImageType} from '@services/resource/image-type';
import {ImageEditorComponent} from '@dashboard/image-editor/image-editor.component';
import {ClientConfig} from '@app/client-config';
import {MarkantDialog, MarkantElementsModule} from '@markant/elements-angular';
import {CommonModule} from '@angular/common';

export class UploadImageConfig {
  constructor(
    public readonly imageType: ImageType,
    public readonly width: number,
    public readonly height: number,
    public readonly expectedMediaTypes: string[],
    public readonly file?: File,
  ) {}
}

@Component({
  selector: 'app-upload-image',
  templateUrl: './upload-image.component.html',
  styleUrls: ['./upload-image.component.scss'],
  standalone: true,
  imports: [CommonModule, MarkantElementsModule, ImageEditorComponent],
})
export class UploadImageComponent {
  maxFileSize = ClientConfig.maxImageSize;
  @Input() selectedImage: ImageResource | null = null;
  @Input() productId: string;
  @Input() startupId: string;
  @Input() width = 200;
  @Input() height = 200;
  @Input() allowNewUpload: boolean;
  @Input() imageType: ImageType;
  @Input() expectedMediaTypes: string[];
  @Input() transmittedImage: File | null = null;
  @Input() imageURL: string | null = null;
  @Input() originUUID: string | null = null;
  @Input() startupName: string | null = null;
  @Input() productName: string | null = null;
  @Input() productCategory: string | null = null;
  @Output() newFileEvent = new EventEmitter<Blob>();
  @Output() cancelEvent = new EventEmitter<boolean>();
  croppedImage: Blob;

  @ViewChild('fileInput', {static: false}) fileInput: ElementRef;
  @ViewChild(ImageEditorComponent, {static: false}) imageEditorComponent: ImageEditorComponent;
  @ViewChild('markantDialog') dialog: MarkantDialog;

  private originalViewport?: string;
  dropzoneActive = false;

  constructor(private readonly fileCheckService: FileCheckService) {}

  dropzoneState($event: boolean) {
    this.dropzoneActive = $event;
  }

  handleFileInput(file: FileList) {
    if (file) {
      return this.handleFile(file.item(0)!);
    }
    return null;
  }

  handleFile(file: File) {
    const errors = this.fileCheckService.checkFile(file, this.expectedMediaTypes, this.maxFileSize);
    if (errors.length === 0) {
      /* now we convert the file to a data url using a FileReader() */
      if (file) {
        const reader = new FileReader();
        reader.onload = (e: any) => {
          this.selectedImage = new ImageResource(this.imageType, e.target.result);
        };
        reader.readAsDataURL(file);
        reader.onloadend = () => undefined;
      }
    } else {
      errors.forEach((error) => {
        // this.snackBar.open(error.message, 'Schließen', { duration: 6000 });
      });
    }
  }

  /** The change event on the input will not trigger if a File is added, removed and added again unless it's value will is reset */
  resetFileInput() {
    this.fileInput.nativeElement.value = null;
  }

  printMediaTypes(): string {
    return this.expectedMediaTypes ? this.expectedMediaTypes.map((m) => m.replace('image/', '.')).join(' ') : 'Alle Bildformate';
  }

  public getImageEditor(): ImageEditorComponent {
    return this.imageEditorComponent;
  }

  upload(cancel: boolean) {
    this.newFileEvent.emit(this.croppedImage);
    this.dialog.open = false;
  }

  saveCroppedImage(event: Blob) {
    this.dialog.open = false;
    this.croppedImage = event;
    this.upload(false);
  }

  dialogClosed() {
    this.dialog.open = false;
    this.cancelEvent.emit(false);
  }

  isCoverImage() {
    return this.imageType.includes(ImageType.COVER);
  }

  reformatProductCategory() {
    if (this.productCategory) {
      return this.productCategory[0].toUpperCase() + this.productCategory.substring(1, this.productCategory.length).toLowerCase();
    }
    return this.productCategory;
  }
}
